import { render } from "./RequestErrorView.vue?vue&type=template&id=2f6b6d06&scoped=true"
import script from "./RequestErrorView.vue?vue&type=script&lang=js"
export * from "./RequestErrorView.vue?vue&type=script&lang=js"

import "./RequestErrorView.vue?vue&type=style&index=0&id=2f6b6d06&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6b6d06"]])

export default __exports__